import React from 'react';
import { motion } from 'framer-motion';
const phases = [{
  days: 'Días 1-3',
  title: "Apagamos el 'incendio' químico",
  description: 'Con el protocolo de frío y posiciones de rescate para detener el dolor agudo inmediatamente.',
  color: 'bg-crimson',
  borderColor: 'border-crimson',
  textColor: 'text-crimson'
}, {
  days: 'Días 4-10',
  title: 'Descompresión pasiva',
  description: 'Aplicamos la descompresión pasiva para crear espacio intervertebral y liberar el nervio atrapado.',
  color: 'bg-navy',
  borderColor: 'border-navy',
  textColor: 'text-navy'
}, {
  days: 'Días 11-14',
  title: 'Blindaje lumbar',
  description: 'Fortalecemos tus hábitos de movimiento para que el dolor no regrese nunca más al trabajar.',
  color: 'bg-green',
  borderColor: 'border-green',
  textColor: 'text-green'
}];
export function TimelineSection() {
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-161">
      <div className="max-w-3xl mx-auto" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-163">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-charcoal" data-id="element-164">
            Cómo funciona el protocolo
          </h2>
        </motion.div>

        <div className="relative" data-id="element-165">
          {/* Vertical connecting line */}
          <div className="absolute left-[27px] md:left-[39px] top-4 bottom-12 w-1 bg-gray-200 rounded-full" data-id="element-166"></div>

          <div className="space-y-12" data-id="element-167">
            {phases.map((phase, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative pl-20 md:pl-28" data-id="element-168">
                {/* Number Circle */}
                <div className={`absolute left-0 top-0 w-14 h-14 md:w-20 md:h-20 rounded-full border-4 border-white shadow-md flex items-center justify-center ${phase.color} text-white font-heading font-bold text-xl md:text-2xl z-10`} data-id="element-169">
                  {index + 1}
                </div>

                <div className="bg-white p-6 md:p-8 rounded-xl shadow-sm border border-gray-100" data-id="element-170">
                  <span className={`inline-block px-3 py-1 rounded-full text-sm font-bold mb-3 bg-opacity-10 ${phase.color.replace('bg-', 'bg-')}/10 ${phase.textColor}`} data-id="element-171">
                    {phase.days}
                  </span>
                  <h3 className="font-heading font-bold text-xl md:text-2xl text-charcoal mb-3" data-id="element-172">
                    {phase.title}
                  </h3>
                  <p className="font-body text-warm-gray leading-relaxed" data-id="element-173">
                    {phase.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}